var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.purchase
    ? _c(
        "div",
        { staticClass: "atmo-hash-jump-point", attrs: { id: "atmo-top" } },
        [
          _c("section", { staticClass: "atmo-fast-access-menu" }, [
            _c("ul", { staticClass: "atmo-container-fixed" }, [
              _vm._m(0),
              _vm._m(1),
              _vm._m(2),
              _vm.purchase.delivery_terms.addresses.length > 0 ||
              _vm.purchase.delivery_terms.schedule
                ? _c("li", [
                    _c("a", { attrs: { href: "#atmo-supply-terms" } }, [
                      _vm._v("Условия поставки"),
                    ]),
                  ])
                : _vm._e(),
              _vm._m(3),
              _vm._m(4),
              _vm._m(5),
              !!_vm.purchase.supplier_proposal
                ? _c("li", [
                    _c("a", { attrs: { href: "#atmo-supplier-info" } }, [
                      _vm._v("Информация о поставщике"),
                    ]),
                  ])
                : _vm._e(),
              _vm.purchase.flags.allow_show_contract
                ? _c("li", [
                    _c("a", { attrs: { href: "#atmo-contract" } }, [
                      _vm._v("Контракт"),
                    ]),
                  ])
                : _vm._e(),
              _vm.purchase.flags.has_contract &&
              _vm.purchase.contract &&
              _vm.purchase.contract.supplementary_agreements &&
              ((_vm.purchase.contract.supplementary_agreements.length === 0 &&
                _vm.$store.getters.isLoggedIn &&
                _vm.purchase.is_customer &&
                _vm.purchase.actions.customer.supplementary_agreement !==
                  "disallow") ||
                _vm.purchase.contract.supplementary_agreements.length > 0)
                ? _c("li", [
                    _c("a", { attrs: { href: "#atmo-contract-annexes" } }, [
                      _vm._v("Дополнительные соглашения"),
                    ]),
                  ])
                : _vm._e(),
              _vm.purchase.flags.has_contract_fulfillment
                ? _c("li", [
                    _c("a", { attrs: { href: "#atmo-contract-fulfillment" } }, [
                      _vm._v("Исполнение контракта"),
                    ]),
                  ])
                : _vm._e(),
              _vm._m(6),
            ]),
          ]),
          _c(
            "b-container",
            { staticClass: "main_layer py-2", attrs: { fluid: "" } },
            [
              _c("b-container", [
                _c("p", { staticClass: "fs-40 fw-600 white-color my-2" }, [
                  _vm._v(
                    "Закупка 44ФЗ с неопределённым объёмом - № " +
                      _vm._s(_vm.purchase.reg_number)
                  ),
                ]),
                _c("p", { staticClass: "white-color fs-14" }, [
                  _c("b", [_vm._v("Статус")]),
                  _vm._v(": " + _vm._s(_vm.purchase.status.title)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "b-container",
            { staticClass: "my-2", attrs: { fluid: "" } },
            [
              _c(
                "b-container",
                [
                  _c(
                    "text-header",
                    {
                      staticClass: "atmo-hash-jump-point",
                      attrs: { id: "atmo-customer-info" },
                    },
                    [_vm._v("Информация о заказчике")]
                  ),
                  _c("text-row-link", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Наименование",
                      "router-link": {
                        name: "OrganizationShow",
                        params: { id: _vm.purchase.customer.id },
                      },
                    },
                    model: {
                      value: _vm.purchase.customer.full_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "full_name", $$v)
                      },
                      expression: "purchase.customer.full_name",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Рейтинг",
                      value: _vm.$formatPrice(
                        _vm.purchase.customer.customer_rating
                      ),
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "ИНН",
                    },
                    model: {
                      value: _vm.purchase.customer.inn,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "inn", $$v)
                      },
                      expression: "purchase.customer.inn",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "КПП",
                    },
                    model: {
                      value: _vm.purchase.customer.kpp,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "kpp", $$v)
                      },
                      expression: "purchase.customer.kpp",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "ОГРН",
                    },
                    model: {
                      value: _vm.purchase.customer.ogrn,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "ogrn", $$v)
                      },
                      expression: "purchase.customer.ogrn",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Юридический адрес",
                    },
                    model: {
                      value: _vm.purchase.customer.legal_address,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase.customer, "legal_address", $$v)
                      },
                      expression: "purchase.customer.legal_address",
                    },
                  }),
                  _vm.purchase.purchase_terms.contact_info
                    ? _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Дополнительная контактная информация",
                        },
                        model: {
                          value: _vm.purchase.purchase_terms.contact_info,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.purchase.purchase_terms,
                              "contact_info",
                              $$v
                            )
                          },
                          expression: "purchase.purchase_terms.contact_info",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "text-header",
                    {
                      staticClass: "atmo-hash-jump-point",
                      attrs: { id: "atmo-purchase-terms" },
                    },
                    [_vm._v("Условия закупки")]
                  ),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Предмет закупки",
                      value: _vm.purchase.purchase_terms.deliverable_group.name,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Объект закупки",
                      value: _vm.purchase.purchase_terms.purchase_object,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Тип закупки",
                      value: _vm.purchase.purchase_terms.order_type.name,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Продолжительность закупочной сессии",
                      value: _vm.purchase.purchase_terms.duration_type.name,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Год ПГ (Плана-графика)",
                      value: _vm.purchase.purchase_terms.purchase_limit_year,
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Размер аванса, %",
                      value: _vm.purchase.purchase_terms.advance_percentage,
                    },
                  }),
                  _c("text-row-price", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Цена контракта",
                      value: _vm.purchase.purchase_terms.contract_price,
                    },
                  }),
                  _c("text-row-datetime", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Дата и время размещения закупки",
                      value: _vm.purchase.published_at,
                    },
                  }),
                  _c("text-row-datetime", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Дата и время окончания приема предложений",
                      value: _vm.purchase.purchase_end,
                    },
                  }),
                  _c("text-row-date", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Планируемая дата заключения договора",
                      value:
                        _vm.purchase.purchase_terms
                          .planned_contract_conclusion_date,
                    },
                  }),
                  _c("text-row-date", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Планируемая дата исполнения договора",
                      value:
                        _vm.purchase.purchase_terms
                          .planned_contract_execution_date,
                    },
                  }),
                  _c("text-row-single-document", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label: "Проект ГК",
                      value:
                        _vm.purchase.purchase_terms.contract_draft_attachment,
                    },
                  }),
                  _vm.purchase.purchase_terms
                    .commercial_proposal_form_attachment
                    ? _c("text-row-single-document", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label:
                            "Образец коммерческого предложения для заполнения",
                          value:
                            _vm.purchase.purchase_terms
                              .commercial_proposal_form_attachment,
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.additional_documents.length > 0
                    ? _c("text-row-documents", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Дополнительные документы",
                        },
                        model: {
                          value: _vm.purchase.additional_documents,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase, "additional_documents", $$v)
                          },
                          expression: "purchase.additional_documents",
                        },
                      })
                    : _vm._e(),
                  _c("text-row", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 4,
                      "label-cols-sm": 4,
                      label:
                        "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                      value:
                        _vm.purchase.purchase_terms
                          .unilateral_contract_termination_info ?? "Нет",
                      "text-wrap": "",
                    },
                  }),
                  _c(
                    "text-header",
                    {
                      staticClass: "atmo-hash-jump-point",
                      attrs: { id: "atmo-supplier-requirements" },
                    },
                    [_vm._v("Требования к участникам закупки")]
                  ),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Участником закупки могут быть только субъекты малого предпринимательства (СМП)",
                      value: _vm.purchase.supplier_requirements.only_smp,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла",
                      value:
                        _vm.purchase.supplier_requirements.supplier_reqs_rating,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                      value: _vm.purchase.supplier_requirements.supplier_reqs_a,
                      "value-class": "text-right",
                    },
                  }),
                  _vm.purchase.supplier_requirements.supplier_reqs_a
                    ? _c(
                        "b-container",
                        [
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Описание требований",
                              value:
                                _vm.purchase.supplier_requirements
                                  .supplier_reqs_a_details.supplier_reqs_a_text,
                              "text-wrap": "",
                            },
                          }),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                "label-cols-sm": 4,
                                "label-cols-lg": 4,
                                label: "Подтверждающие документы:",
                                "label-class":
                                  "fs-14 grey-color fw-700 d-flex align-items-baseline",
                              },
                            },
                            [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.purchase.supplier_requirements
                                    .supplier_reqs_a_details
                                    .supplier_reqs_a_documents,
                                  function (item, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                        staticClass:
                                          "fs-14 grey-color my-auto col-form-label pb-0",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(index + 1 + ". " + item.name)
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                      value: _vm.purchase.supplier_requirements.supplier_reqs_b,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                      value: _vm.purchase.supplier_requirements.supplier_reqs_c,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label:
                        "Участник является социально ориентированной некоммерческой организацией (СОНКО)",
                      value:
                        _vm.purchase.supplier_requirements.supplier_reqs_sonko,
                      "value-class": "text-right",
                    },
                  }),
                  _c("text-row-boolean-text", {
                    attrs: {
                      compact: "",
                      "label-cols-lg": 11,
                      "label-cols-sm": 11,
                      label: "Дополнительные требования к участникам закупки",
                      value:
                        _vm.purchase.supplier_requirements
                          .has_additional_requirements,
                      "value-class": "text-right",
                    },
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.purchase.supplier_requirements
                              .has_additional_requirements,
                          expression:
                            "purchase.supplier_requirements.has_additional_requirements",
                        },
                      ],
                    },
                    [
                      _c("section", { staticStyle: { width: "100%" } }, [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            { staticClass: "atmo-content-table mb-0" },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "atmo-ctc-width-45pct py-1",
                                    },
                                    [_vm._v("Описание")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "atmo-ctc-width-45pct py-1",
                                    },
                                    [
                                      _vm._v(
                                        "Причина или цель установки требования"
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.purchase.supplier_requirements
                                    .additional_requirements,
                                  function (requirement, index) {
                                    return _c("tr", { key: index }, [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "atmo-ctc-width-45pct py-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(requirement.description)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "atmo-ctc-width-45pct py-1",
                                        },
                                        [_vm._v(_vm._s(requirement.reason))]
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm.purchase.delivery_terms.addresses.length > 0 ||
                  _vm.purchase.delivery_terms.schedule
                    ? [
                        _c(
                          "text-header",
                          {
                            staticClass: "atmo-hash-jump-point",
                            attrs: { id: "atmo-supply-terms" },
                          },
                          [_vm._v("Условия поставки")]
                        ),
                        _vm.purchase.delivery_terms.addresses.length > 0
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": 4,
                                  "label-cols-lg": 4,
                                  label: "Адреса для доставки/самовывоза:",
                                  "label-class":
                                    "pt-0 pb-2 fs-14 grey-color fw-700 d-flex align-items-baseline",
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  { staticClass: "pb-2" },
                                  _vm._l(
                                    _vm.purchase.delivery_terms.addresses,
                                    function (address, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "py-0 fs-14 grey-color my-auto col-form-label",
                                        },
                                        [_vm._v(_vm._s(address))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("text-row", {
                          attrs: {
                            compact: "",
                            "label-cols-lg": 4,
                            "label-cols-sm": 4,
                            label:
                              "График поставки товаров (выполнения работ, оказания услуг)",
                            value: _vm.purchase.delivery_terms.schedule,
                          },
                        }),
                      ]
                    : _vm._e(),
                  _c("form-row-specification-table-view", {
                    staticClass: "atmo-hash-jump-point",
                    attrs: {
                      id: "atmo-notice-deliverables",
                      "without-count": "",
                    },
                    model: {
                      value: _vm.purchase.deliverables,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "deliverables", $$v)
                      },
                      expression: "purchase.deliverables",
                    },
                  }),
                  _vm.$store.getters.isLoggedIn &&
                  _vm.purchase.is_customer &&
                  !_vm.purchase.purchase_terms.without_limits
                    ? _c("limits-table", {
                        attrs: { items: _vm.purchase.limits },
                      })
                    : _vm._e(),
                  _c(
                    "AccordionItem",
                    {
                      staticClass: "atmo-hash-jump-point pb-0",
                      attrs: {
                        visible: _vm.$route.hash === "#explanation-requests",
                        title: "Запросы разъяснений по закупке",
                        id: "explanation-requests",
                      },
                    },
                    [
                      !!_vm.purchase.id
                        ? _c("ExplanationRequestList", {
                            attrs: {
                              "purchase-item": _vm.purchase,
                              "purchase-type": "fl44UnknownVolume",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("fl44-unknown-volume-proposals-block", {
                    attrs: { purchase: _vm.purchase },
                  }),
                  _vm.$store.getters.isLoggedIn &&
                  _vm.purchase.is_customer &&
                  _vm.purchase.actions.customer.select_winner
                    ? _c("fl44-unknown-volume-summarizing-block", {
                        attrs: { purchase: _vm.purchase },
                        on: {
                          refresh: function ($event) {
                            return _vm.refresh($event)
                          },
                        },
                      })
                    : _vm._e(),
                  !!_vm.purchase.supplier_proposal
                    ? _c("fl44-unknown-volume-supplier-info-block", {
                        staticClass: "atmo-hash-jump-point",
                        attrs: {
                          id: "atmo-notice-deliverables",
                          proposal: _vm.purchase.supplier_proposal,
                          "show-documents": _vm.purchase.is_customer,
                          "is-participant": _vm.purchase.flags.is_participant,
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.flags.allow_show_contract
                    ? _c("fl44-unknown-volume-contract-block", {
                        attrs: { purchase: _vm.purchase },
                        on: {
                          refresh: function ($event) {
                            return _vm.refresh($event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.flags.has_contract_fulfillment
                    ? _c("fl44-unknown-volume-contract-fulfillment-block", {
                        attrs: { purchase: _vm.purchase },
                        on: {
                          refresh: function ($event) {
                            return _vm.refresh($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-container",
            {
              staticClass: "my-4",
              attrs: { fluid: "", id: "action_buttons_row" },
            },
            [
              _c(
                "b-container",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-row",
                    { staticClass: "my-3 mt-5" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "fl44-unknown-volume-download-purchase-pdf-button",
                            {
                              attrs: {
                                "purchase-id": _vm.purchase.id,
                                "reg-number": _vm.purchase.reg_number,
                              },
                            }
                          ),
                          _c("signature-xml-info-button", {
                            staticClass: "mt-2 ml-2",
                            attrs: {
                              title: "Электронная подпись к извещению",
                              "customer-signature": _vm.purchase.signature,
                              "allow-download-xml":
                                _vm.purchase.flags.is_participant,
                              filename:
                                "purchase_signature_info_" +
                                _vm.purchase.reg_number,
                            },
                          }),
                          _vm.$store.getters.isLoggedIn
                            ? _c("fl44-unknown-volume-new-proposal-button", {
                                attrs: { "notice-item": _vm.purchase },
                              })
                            : _vm._e(),
                          _vm.purchase.flags.has_final_protocol ||
                          this.purchase.status.id === "failed" ||
                          _vm.purchase.flags.has_contract
                            ? _c(
                                "fl44-unknown-volume-download-purchase-final-protocol-pdf-button",
                                {
                                  attrs: {
                                    "purchase-id": _vm.purchase.id,
                                    "reg-number": _vm.purchase.reg_number,
                                  },
                                }
                              )
                            : _vm._e(),
                          _vm.purchase.flags.has_contract &&
                          _vm.purchase.status.id !== "contract:failed"
                            ? [
                                _c(
                                  "fl44-unknown-volume-download-purchase-contract-pdf-button",
                                  {
                                    attrs: {
                                      "purchase-id": _vm.purchase.id,
                                      reg_number: _vm.purchase.reg_number,
                                    },
                                  }
                                ),
                                _vm.purchase.contract.customer_signature ||
                                _vm.purchase.contract.supplier_signature
                                  ? _c("signature-xml-info-button", {
                                      staticClass: "mt-2 ml-2",
                                      attrs: {
                                        title:
                                          "Электронная подпись к контракту",
                                        "customer-signature":
                                          _vm.purchase.contract
                                            .customer_signature,
                                        "supplier-signature":
                                          _vm.purchase.contract
                                            .supplier_signature,
                                        "allow-download-xml":
                                          _vm.purchase.flags.is_participant,
                                        filename:
                                          "purchase_contract_signature_info_" +
                                          _vm.purchase.reg_number,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "atmo-hash-jump-point",
            attrs: { id: "atmo-bottom" },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "#atmo-customer-info" } }, [
        _vm._v("Информация о заказчике"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "#atmo-purchase-terms" } }, [
        _vm._v("Условия закупки"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "#atmo-supplier-requirements" } }, [
        _vm._v("Требования к участникам закупки"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "#atmo-notice-deliverables" } }, [
        _vm._v("Спецификация"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "#explanation-requests" } }, [
        _vm._v("Запросы разъяснений по закупке"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "#atmo-proposals" } }, [
        _vm._v("Предложения участников закупочной сессии"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "atmo-group" }, [
      _c("li", { attrs: { title: "К верху страницы" } }, [
        _c(
          "a",
          { staticClass: "atmo-button-icon", attrs: { href: "#atmo-top" } },
          [_c("i", { staticClass: "atmo-icon-angle-up" })]
        ),
      ]),
      _c("li", { attrs: { title: "К низу страницы" } }, [
        _c(
          "a",
          { staticClass: "atmo-button-icon", attrs: { href: "#atmo-bottom" } },
          [_c("i", { staticClass: "atmo-icon-angle-down" })]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }